import { render, staticRenderFns } from "./sorttool.vue?vue&type=template&id=0bc80d03&scoped=true"
import script from "./sorttool.vue?vue&type=script&lang=js"
export * from "./sorttool.vue?vue&type=script&lang=js"
import style0 from "./sorttool.vue?vue&type=style&index=0&id=0bc80d03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc80d03",
  null
  
)

export default component.exports